import { useContext } from "react";
import "./style.css";
import { ThemeContext } from "../../App";
const RecipeItem = ({ item, addToFavorites }) => {
  const { title, image, id } = item;

  const { theme } = useContext(ThemeContext);
  return (
    <div className="recipe-item">
      <div>
        <img src={image} alt={title} />
      </div>
      <h3>{title}</h3>
      <button className="btn" type="button" onClick={addToFavorites}>
        Add to favorite
      </button>
    </div>
  );
};

export default RecipeItem;
